module.exports = __webpack_public_path__ + "static/media/mirko-stocker.852f5141.jpg";